import React from 'react'
import "./SearchBar.css"
import SearchResult from "./SearchResult"
import { Button } from "@material-ui/core";

function SearchBar() {
    return (
        <div className="searchbar">
            <div className="searchpage__info">
                <p>62 stays : 15 September to 30 Auguest : 2 
                Guest</p>
                <h1>Stays nearby</h1>
                <Button variant="outlined">Cancellation Flexibility</Button>
                <Button variant="outlined">Type of place</Button>
                <Button variant="outlined">Price</Button>
                <Button variant="outlined">Rooms and beds</Button>
                <Button variant="outlined">More filters</Button>
            </div>
            <SearchResult
                img="https://images.unsplash.com/photo-1460627390041-532a28402358?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80"
                location="London"
                title="London joker toy hotel"
                des="1 guest · 1 bedroom · 1 bed · 1.5 shared bthrooms · Wifi · Kitchen · Free parking · Washing Machine"
                star={4.73}
                price="30,000 / night"
                total="40,000 total"
            />

<SearchResult
                img="https://images.unsplash.com/photo-1470214203634-e436a8848e23?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjF9&auto=format&fit=crop&w=1191&q=80"
                location="Dubai"
                title="Tiker fuccer Dubai royal hotel"
                des="1 guest · 1 bedroom · 1 bed · 1.5 shared bthrooms · Wifi · Kitchen · Free parking · Washing Machine"
                star={5.00}
                price="50,000 / night"
                total="55,000 total"
            />


<SearchResult
                img="https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80"
                location="Thailand"
                title="Thaio leo golden blue hotel"
                des="1 guest · 1 bedroom · 1 bed · 1.5 shared bthrooms · Wifi · Kitchen · Free parking · Washing Machine"
                star={4.05}
                price="20,000 / night"
                total="40,000 total"
            />
            <SearchResult
                img="https://images.unsplash.com/photo-1460627390041-532a28402358?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80"
                location="London"
                title="London joker toy hotel"
                des="1 guest · 1 bedroom · 1 bed · 1.5 shared bthrooms · Wifi · Kitchen · Free parking · Washing Machine"
                star={4.73}
                price="30,000 / night"
                total="40,000 total"
            />

<SearchResult
                img="https://images.unsplash.com/photo-1470214203634-e436a8848e23?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjF9&auto=format&fit=crop&w=1191&q=80"
                location="Dubai"
                title="Tiker fuccer Dubai royal hotel"
                des="1 guest · 1 bedroom · 1 bed · 1.5 shared bthrooms · Wifi · Kitchen · Free parking · Washing Machine"
                star={5.00}
                price="50,000 / night"
                total="55,000 total"
            />


<SearchResult
                img="https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80"
                location="Thailand"
                title="Thaio leo golden blue hotel"
                des="1 guest · 1 bedroom · 1 bed · 1.5 shared bthrooms · Wifi · Kitchen · Free parking · Washing Machine"
                star={4.05}
                price="20,000 / night"
                total="40,000 total"
            />
            <SearchResult
                img="https://images.unsplash.com/photo-1460627390041-532a28402358?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80"
                location="London"
                title="London joker toy hotel"
                des="1 guest · 1 bedroom · 1 bed · 1.5 shared bthrooms · Wifi · Kitchen · Free parking · Washing Machine"
                star={4.73}
                price="30,000 / night"
                total="40,000 total"
            />


<SearchResult
                img="https://images.unsplash.com/photo-1470214203634-e436a8848e23?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjF9&auto=format&fit=crop&w=1191&q=80"
                location="Dubai"
                title="Tiker fuccer Dubai royal hotel"
                des="1 guest · 1 bedroom · 1 bed · 1.5 shared bthrooms · Wifi · Kitchen · Free parking · Washing Machine"
                star={5.00}
                price="50,000 / night"
                total="55,000 total"
            />


<SearchResult
                img="https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80"
                location="Thailand"
                title="Thaio leo golden blue hotel"
                des="1 guest · 1 bedroom · 1 bed · 1.5 shared bthrooms · Wifi · Kitchen · Free parking · Washing Machine"
                star={4.05}
                price="20,000 / night"
                total="40,000 total"
            />
<SearchResult
                img="https://images.unsplash.com/photo-1460627390041-532a28402358?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80"
                location="London"
                title="London joker toy hotel"
                des="1 guest · 1 bedroom · 1 bed · 1.5 shared bthrooms · Wifi · Kitchen · Free parking · Washing Machine"
                star={4.73}
                price="30,000 / night"
                total="40,000 total"
            />

<SearchResult
                img="https://images.unsplash.com/photo-1470214203634-e436a8848e23?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjF9&auto=format&fit=crop&w=1191&q=80"
                location="Dubai"
                title="Tiker fuccer Dubai royal hotel"
                des="1 guest · 1 bedroom · 1 bed · 1.5 shared bthrooms · Wifi · Kitchen · Free parking · Washing Machine"
                star={5.00}
                price="50,000 / night"
                total="55,000 total"
            />


<SearchResult
                img="https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80"
                location="Thailand"
                title="Thaio leo golden blue hotel"
                des="1 guest · 1 bedroom · 1 bed · 1.5 shared bthrooms · Wifi · Kitchen · Free parking · Washing Machine"
                star={4.05}
                price="20,000 / night"
                total="40,000 total"
            />

        </div>
         
    )
}

export default SearchBar
